  (function () {
    function initTestimonialsCarousel(carousel) {
      if (!carousel) return;

      const slides = Array.from(carousel.querySelectorAll('.testimonial-slide'));
      const dots = Array.from(carousel.querySelectorAll('.testimonial-slide__dot'));

      if (!slides.length || !dots.length) return;

      let activeIndex = 0;
      let autoplayTimer = null;

      function setActiveSlide(index) {
        activeIndex = index;

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function startAutoplay() {
        if (slides.length <= 1) return;

        if (autoplayTimer) {
          clearInterval(autoplayTimer);
        }

        autoplayTimer = setInterval(function () {
          const nextIndex = (activeIndex + 1) % slides.length;
          setActiveSlide(nextIndex);
        }, 10000);
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = Number(this.dataset.target);
          setActiveSlide(index);
          startAutoplay();
        });
      });

      setActiveSlide(activeIndex);
      startAutoplay();
    }

    function runInit() {
      document
        .querySelectorAll('[data-testimonials-carousel]:not([data-judgeme-testimonials])')
        .forEach(initTestimonialsCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit);
    } else {
      runInit();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      event.target
        .querySelectorAll('[data-testimonials-carousel]:not([data-judgeme-testimonials])')
        .forEach(initTestimonialsCarousel);
    });

    document.addEventListener('testimonials:ready', function (event) {
      initTestimonialsCarousel(event.target);
    });
  })();